import { useTranslation } from "@/common/providers/i18n-provider";
import { PRICING_FAQS } from "@/components/pricing/pricing-faq";
import { OWN_PRICE_PARAMS } from "@/lib/price-format";

/**
 * Pricing FAQ accordion (native <details>/<summary>, keyboard-accessible).
 * The same Q&As ship as FAQPage JSON-LD from the pricing routes' head().
 */
export function PricingFaq() {
  const { t } = useTranslation();
  return (
    <section className="pricing-faq" aria-labelledby="pricing-faq-title">
      <h2 id="pricing-faq-title">{t("pricing.faq.heading")}</h2>
      <div>
        {PRICING_FAQS.map((faq) => (
          <details key={faq.qKey}>
            <summary>
              {t(faq.qKey)}
              <span aria-hidden="true">+</span>
            </summary>
            <p>{t(faq.aKey, OWN_PRICE_PARAMS)}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
